import { Box, Button, Grid, styled, Typography } from "@mui/material";
import AuthenticateLayout from "../../components/AuthenticateLayout";
import QRCodeScanDialog from "../../components/QRCodeScanDialog";
import { useEffect, useRef, useState } from "react";
import Barcode from "react-barcode";
import QRCode from "react-qr-code";
import GiftIcon from "../../assets/icons/gift2.svg";
import QRScanner from "../../components/QRCodeScanner";
import { ExpiredDate } from "../multi-coupons/MultiCoupons.styles";
import SVG from "react-inlinesvg";
import { links } from "../../constants/links";
import { useLocation, useNavigate } from "react-router-dom";
import { getCouponDetail } from "../../services/ads/ads.service";
import { Loading } from "../../components";
import { commonDateFormat } from "../../utils/date-format";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { isExpiredToday } from "../../utils/utils";
import { IoMdCopy } from "react-icons/io";
import { scanToRedeemButtonStyle } from "../../components/Buttons";
import ChangeLanguage from "../../components/ChangeLanguage";
import { ReportErrorLink } from "../../components/ReportErrorLink";
import { TnC } from "../../components/TnC";
import { Footer } from "../../components/Footer";
import { ENV } from "../../configs/env";


const UseRewardWrapper = styled(Box)({
  width: "100%",
  "& .body": {
    position: "absolute",
    width: "100%",
    paddingBottom: 20,
    "& .footerBox": {
      margin: "0 calc((100% - 333px) / 2)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: 15,
      ".notice_text": {
        fontWeight: 500
      },
      "& .notice": {
        color: "#DA314F"
      }
    },
  }
});

const QRCodeWrapper = styled(Box)({
  width: 333,
  height: "100%",
  borderRadius: "10px",
  background: "#fff",
  margin: "0 calc((100% - 333px) / 2)",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  border: "1px solid #EBEBEB",
  boxShadow: "0px 19px 38px rgba(58, 76, 130, 0.1)",
  padding: 20,
});

const ReportButtonWrapper = styled(Box)({
  marginTop: 20,
  width: 330,
  height: "100%",
});

const RedeemCode = styled(Typography)({
  fontSize: 18,
  lineHeight: "21px",
  letterSpacing: "2px",
  color: "#000000"
});

const ScanToRedeemButton = styled(Button)({
  width: "100%",
  marginTop: 23,
  fontSize: 14,
  lineHeight: "17px",
  fontWeight: 300,
  height: 48,
  position: "sticky",
  bottom: 20,
  "& .MuiButton-startIcon": {
    marginRight: 0
  },
  "svg": {
    marginTop: 3,
    width: 41,
    height: 41
  }
});

export const LinkToast = styled(Box)({
  position: "absolute",
  top: "60%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "rgba(0,0,0,0.6)",
  color: "#fff",
  padding: "1px 10px",
  borderRadius: 5,
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.3)",
  zIndex: 1000,
  fontSize: 14,
  animation: "fadein 0.5s ease, fadeout 0.5s ease 1.5s",
  animationFillMode: "forwards",
  "@keyframes fadein": {
    from: { opacity: 0 },
    to: { opacity: 1 }
  },
  "@keyframes fadeout": {
    from: { opacity: 1 },
    to: { opacity: 0, visibility: "hidden" }
  }
});

export const NotificationWrapper = styled(Box)(`
  margin: 0 calc((100% - 333px) / 2);
  background-color: #FDEFE8;
  border: 1px dashed rgba(239, 91, 27, 0.5);
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 15px;
  display: flex;
  align-items: center;
  & .detail {
    color: #333333;
    font-size: 12px;
  };
  & .viewOtherBtn {
    font-size: 12px;
    font-weight: 400;
    padding: 0;
    line-height: 18px;
  }
`);

export const ListStatus = {
  PENDING: "PENDING",
  ENGAGED: "ENGAGED",
  VERIFIED: "VERIFIED",
  COMPLETED: "COMPLETED"
};


interface Languages {
  [key: string]: {
    instructions_image: string;
  };
}

interface InitialData {
  qrscan_image: string;
  reward_banner: string;
  used_at: string;
  expired_at: string;
  coupon_code: string;
  coupon_used_option: string;
  is_for_verified_users: boolean;
  is_line_verified: boolean;
  remain_quantity: number;
  is_expired_or_finished_issued: boolean;
  subcampaign_id: string;
  languages: Languages;
  status: string;
}

const Coupon = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [isScanQr, setIsScanQr] = useState(false);
  const id = location.pathname.split("/")[2];
  const [isLoading, setIsLoading] = useState(true);
  const searchParams = new URLSearchParams(location.search);
  const engage_session_id = useRef(searchParams.get("engage-session") || "");
  const [isLoadedStatus, setIsLoadedStatus] = useState(true);
  const initialData: InitialData = {
    coupon_code: "",
    qrscan_image: "",
    reward_banner: "",
    used_at: "",
    expired_at: "",
    coupon_used_option: "",
    is_for_verified_users: false,
    is_line_verified: false,
    remain_quantity: 0,
    is_expired_or_finished_issued: false,
    subcampaign_id: "",
    languages: {},
    status: ""
  };
  const [data, setData] = useState(initialData);
  const [isUsedOrExpired, setIsUsedOrExpired] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const [showComponent, setShowComponent] = useState(false);
  const [error, setError] = useState(false);
  const goToRewardList = (use?: boolean) => {
    setIsScanQr(false);
    navigate(links.EARN_PAGE + (use ? "?tab=1&is_reload=true" : ""), { state: { engageSession: engage_session_id.current } });
  };
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogInfo, setDialogInfo] = useState({
    is_success: false,
    coupon_code: ""
  });
  const [showMessage, setShowMessage] = useState<boolean>(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowComponent(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);


  useEffect(() => {
    const handlePopState = (event: any) => {
      if (location.state?.fromPath !== "EARN_REWARD") {
        window.history.pushState(null, "", window.location.pathname);
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);


  useEffect(() => {
    if (isLoadedStatus) {
      getCouponDetail({ id: id }).then((detailData: any) => {
        setData(detailData);
        if (detailData?.expired_at) {
          setIsExpired(isExpiredToday(detailData?.expired_at));
        }
        setIsLoadedStatus(false);
      }).finally(() => {
        setIsLoading(false);
      }).catch((error) => {
        setError(true);
        console.log(error);
      });
    }
  }, [isLoadedStatus]);


  const onCam = () => {
    setIsScanQr(true);
  };

  const offCam = () => {
    setIsScanQr(false);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const setDialogInformation = (dialogInformation: any) => {
    setDialogInfo({
      ...dialogInformation,
      coupon_code: data?.coupon_code
    });
  };

  useEffect(() => {
    if (!data?.coupon_code) return;

    const isUsed = !!data?.used_at;
    const isQtyZero = data?.remain_quantity === 0;
    const isInvalid = data?.status === "invalid";

    const result = isUsed || isExpired || isQtyZero || isInvalid;

    setIsUsedOrExpired(result);
  }, [data, isExpired]);


  const barcode = (
    <Barcode
      value={data?.coupon_code ?? ""}
      marginBottom={20}
      displayValue={false}
      lineColor={isUsedOrExpired ? "#DADADA" : "#42436A"}
      width={1.4}
      height={70}
    />
  );

  const qrcode = (
    <QRCode
      size={172}
      value={data?.coupon_code ?? ""}
      viewBox={"0 0 256 256"}
      fgColor={isUsedOrExpired ? "#DADADA" : "#42436A"}
    />);

  const getCouponDisplayMode = () => {
    const couponUsedOption = data?.coupon_used_option;
    switch (couponUsedOption) {
      case "BARCODE":
        return (
          <Barcode
            value={data?.coupon_code ?? ""}
            marginBottom={40}
            marginTop={50}
            displayValue={false}
            lineColor={isUsedOrExpired ? "#DADADA" : "#42436A"}
            width={((data.coupon_code && data.coupon_code.length > 10) ? 1.4 : 1.8)}
            height={100}
          />
        );
      case "QRCODE":
        return qrcode;
      case "BARCODE_QRCODE":
        return (
          <>
            {barcode}
            {qrcode}
          </>
        );
    }
  };

  const FooterContainer = () => (
    <Box className="footerBox">
      {
        data?.coupon_used_option === "COUPON_WITH_INSTRUCTIONS"
          ? <Footer />
          : (
            <>
              {
                !isUsedOrExpired && !isScanQr && (
                  <Typography sx={{
                    color: process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__COUPON_CAN_BE_USED_N_TIMES_TEXT_COLOR || "#000000"
                  }} className="notice_text" fontSize={15}>
                    <span className="notice">*</span>
                    {t("couponBalanceMsg1") + " " + data?.remain_quantity + " " + t("couponBalanceMsg2")}
                  </Typography>
                )
              }
              {
                !isUsedOrExpired ? (
                  <ScanToRedeemButton
                    startIcon={<SVG src={GiftIcon} />}
                    variant="contained"
                    onClick={!isUsedOrExpired ? onCam : undefined}
                    style={scanToRedeemButtonStyle}
                  >
                    {t("scanToRedeem")}
                  </ScanToRedeemButton>
                ) : ""
              }
              <Grid container mt={2}>
                <Grid item xs={12} sx={{ textAlign: "center" }}>
                  <ReportErrorLink />
                </Grid>
              </Grid>
            </>
          )
      }
    </Box>
  );

  const QrScanFromCamera = () => (
    !data.qrscan_image ? <Loading /> : (
      <Grid mt={0.5} container justifyContent="center">
        <img
          src={data?.qrscan_image}
          alt="reward_banner"
          style={
            {
              width: "100%",
              height: "auto",
              maxHeight: "calc(333px - 20px)"
            }
          }
        />
      </Grid>
    )
  );

  const CouponCodeWrapper = () => {
    const copyToClipboard = () => {
      if (data?.coupon_code) {
        if (navigator?.clipboard?.writeText) {
          navigator.clipboard
            .writeText(data.coupon_code)
            .then(() => {
              setShowMessage(true);
              setTimeout(() => { setShowMessage(false); }, 2000);
            })
            .catch((err) => {
              console.error("Failed to copy: ", err);
            });
        } else {
          console.error("Clipboard API is not supported in this browser.");
        }
      }
    };

    return (
      <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-end", alignContent: "Center", gap: "5px" }}>
        <RedeemCode
          mt={1}
          sx={{
            color: isUsedOrExpired ? "#DADADA" : "#000000",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            maxWidth: "220px"
          }}
        >
          {data?.coupon_code}
        </RedeemCode>
        {
          data?.coupon_used_option === "COUPON_WITH_INSTRUCTIONS" &&
          <IoMdCopy size={30} style={{ marginBottom: "-5px" }} onClick={copyToClipboard} />
        }
        {showMessage && <LinkToast>{t("linkCopied")}</LinkToast>}
      </div>
    );
  };

  const OtherCouponUsedType = () => (
    <>
      {data?.coupon_used_option === "COUPON_WITH_INSTRUCTIONS" ?
        (
          (
            <Grid mt={0.5} container justifyContent="center">
              <img
                src={data?.qrscan_image}
                alt="reward_banner"
                style={
                  {
                    width: "100%",
                    height: "auto",
                    maxHeight: "calc(333px - 20px)"
                  }
                }
              />
            </Grid>
          )
        )
        :
        (
          <>
            <TnC />
            <Grid mt={1.75} container justifyContent="center">
              <Typography
                mr={0.5}
                sx={{ fontSize: 14, color: "#8D8D8D", fontWeight: 400 }}
              >
                {isUsedOrExpired ? (data?.used_at ? t("usedDate") : t("expiredDate")) : t("expiredDate")}
              </Typography>
              <ExpiredDate
                sx={{ fontSize: 14, fontWeight: 400 }}
              >
                {isUsedOrExpired ? (data?.used_at ? commonDateFormat(moment(data?.used_at)) : commonDateFormat(moment(data?.expired_at))) : commonDateFormat(moment(data?.expired_at))}
              </ExpiredDate>
            </Grid>
            {getCouponDisplayMode()}
            <Typography
              mt={1}
              sx={{ fontSize: 14, color: "#8D8D8D", fontWeight: 400 }}
            >
              {t("yourRedeemCode")}
            </Typography>
          </>
        )
      }
      <CouponCodeWrapper />
    </>
  );


  return (
    isScanQr
      ? (
        <>
          <QRScanner
            coupon_code={data?.coupon_code}
            setDialogInformation={setDialogInformation}
            handleDialogOpen={handleDialogOpen}
            offCam={offCam}
            isAnonymousRedemption={true}
          />
          {
            openDialog
              ? (
                <QRCodeScanDialog
                  open={openDialog}
                  offCam={offCam}
                  onClose={handleDialogClose} {...dialogInfo}
                />
              )
              : ""
          }
        </>
      )
      : (
        <>
          {!showComponent && <Loading customBackgroundColor="rgba(255,255,255,1)" />}
          <AuthenticateLayout
            button={() => !ENV.HIDE_TRANSLATOR && <ChangeLanguage />}
            background={data?.reward_banner}
            isLoading={isLoading}
            hideLogo={ENV.HIDE_LOGO}
          >
            {isLoading && <Loading />}
            <UseRewardWrapper>
              <Box className="body" sx={{ left: 0, top: 118 }}>
                <QRCodeWrapper>
                  {(!data?.coupon_used_option) && <Loading customBackgroundColor="rgba(255,255,255,1)" />}
                  {data?.coupon_used_option === "QRSCANNER_FROM_CAMERA" && <QrScanFromCamera />}
                  {data?.coupon_used_option !== "QRSCANNER_FROM_CAMERA" && <OtherCouponUsedType />}
                </QRCodeWrapper>
                <FooterContainer />
              </Box>
            </UseRewardWrapper>
          </AuthenticateLayout>
        </>
      )
  );
};

export default Coupon;
